import { Type } from 'class-transformer';
import { Lager } from './Lager';
import { Lagerplatz } from './Lagerplatz';

export class LagerplatzStartEtikettResult {
    @Type(() => Lager)
    public lager: Lager;
    @Type(() => Lagerplatz)
    public lagerplatz: Lagerplatz;
    public warnmeldung: string;
}



// WEBPACK FOOTER //
// ./src/providers/rest-server/data/LagerplatzStartEitkettResult.ts